<template>
  <CardComponent class="journal-component d-flex flex-column pb-2">
    <div class="busy-holder"></div>
    <template v-slot:title>{{ $t('lead.journal.title') }}</template>
    <v-text-field v-model="newEntryContent"
                  class="mx-1"
                  :placeholder="$t('lead.journal.placeholder')"
                  @keyup.enter="$emit('newEntry', newEntryContent); newEntryContent=''"/>
    <div class="journal-component-list mr-1">
      <JournalEntryComponent v-for="(entry, index) in entries" :key="index" v-bind="entry" class="mr-1">
        <img :src="entry.image" v-if="entry.image" width="48"/>
      </JournalEntryComponent>
    </div>
  </CardComponent>    
</template>

<script>
import {ref} from '@vue/composition-api'

import JournalEntryComponent from "@/components/lead/journal/JournalEntryComponent";
import CardComponent from "@/components/form/CardComponent";
export default {
name: "JournalComponent",
  components: {CardComponent, JournalEntryComponent},
  props: {
    entries: Array
  },
  setup(){
    const newEntryContent = ref('')
    return {newEntryContent}
  }
}
</script>

<style lang="scss">

.journal-component {
  position: relative;
  max-height: 100%;

  &::before {
    position: absolute;
    top: 114px;
    left: 0;
    right: 32px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 1%, rgba(255, 255, 255, 0) 100%);
    content: '';
    height: 32px;
  }

  &::after {
    position: absolute;
    left: 0;
    right: 32px;
    bottom: 32px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 1%, rgba(255, 255, 255, 1) 100%);
    content: '';
    height: 32px;
  }

  .v-text-field {
    > .v-input__control > .v-input__slot:before {
      border-color: #8EA2A8;
    }

    input {
      &::placeholder {
        font-weight: 500;
      }
    }
  }

  .journal-component-list {
    overflow-y: auto;
    padding-bottom: 32px;
  }

  &.busy .busy-holder{
    &::before{
      content: ' ';
      display: block;
      position: absolute;
      z-index: 10000;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.6);
      cursor: wait;
    } 
  }
}
</style>
